import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import ConditionalRender from './ConditionalRender';

export const HIDE = 'Hide child';
export const RENDERNULL = 'Render null';
export const DONOTHING = 'Do nothing';

const schema: JSONSchema7 = {
    title: 'Conditional Render',
    description: `1. Function must return true or false to accept a child component
    2. Remove border used as guard. eg border: none after setting up child component`,
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet. Remove guide border when not required',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        action: {
            type: 'string',
            title: 'Action ',
            enum: [HIDE, RENDERNULL, DONOTHING],
            description: 'Choose render action',
            default: DONOTHING,
        },
        functionToBoolean: {
            type: 'string',
            description: 'Function that should resolve to boolean',
            default: 'return (data) => { return null }',
        },
    },
    dependencies: {
        action: {
            oneOf: [
                {
                    properties: {
                        action: { enum: [DONOTHING] },
                    },
                },
                {
                    properties: {
                        action: { enum: [RENDERNULL] },
                    },
                },
                {
                    properties: {
                        action: { enum: [HIDE] },
                    },
                },
            ],
        },
        dependencies: {
            ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['action', 'functionToBoolean'],
    },
];

const ConditionalRenderWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToBoolean: { 'ui:widget': 'JSEditor' },
    },
    templateView: ConditionalRender,
    id: 'ConditionalRender',
    group: 'component',
    contentPlaceHolders: ['conditionalRender'],
    initialData: () => ({}),
};

export default ConditionalRenderWidget;
